import React, { useState } from 'react'
import Layout, { Container } from "../components/layout";
import { useNavigate } from 'react-router-dom';
import { useUser } from "../config/userProvider";
import { apiurl } from "../config/config";
import {
  BlackButton,
} from "../components/buttonContainer";
import BackHeader from "../components/backHeader";
import axios from "axios";
// import { AiTwotoneEdit } from "react-icons/ai";
// import { RiDeleteBin6Fill } from "react-icons/ri";
// import { IoMdArrowRoundBack } from "react-icons/io";
// import Form from "../components/formComponents";
import Input from '../components/inputContainer';
import { toast } from "react-toastify";
import { CountryAndStateData } from "../constants/constant";



function AddCustomer() {
  const navigate = useNavigate();
  const { userData } = useUser();
  const vendorObjId = userData?.vendorDetails?.vendorObjId;

  const [loading, setLoading] = useState(false)
  const [states, setStates] = useState([]);

  const [formdata, setFormdata] = useState({
    name: "",
    email: "",
    phone: "",
    // role: "user",
    description: "",
    city: "",
    zip: "",
    // province: "",
    address: "",
    country: "",
    country_code: "",
    state: "",
    province_code: "",
  });

  console.log("FORMDATA", formdata);

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;

  //   // Validate phone number to ensure it is only digits and not more than 10 digits
  //   if (name === "phone") {
  //     const isValidPhone = /^\d{0,10}$/.test(value); // Allow only up to 10 digits
  //     if (!isValidPhone) return; // Exit if the phone number is invalid
  //   }

  //   setFormdata({ ...formdata, [name]: value });
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Validate phone number to ensure it is only digits and not more than 10 digits
    if (name === "phone") {
      const isValidPhone = /^\d{0,10}$/.test(value); // Allow only up to 10 digits
      if (!isValidPhone) return; // Exit if the phone number is invalid
    }

    // Handle country selection
    if (name === "country") {
      const selectedCountry = CountryAndStateData[value];
      if (selectedCountry) {
        const { name: countryName, states } = selectedCountry;
        setStates(Object.entries(states)); // Update states dropdown dynamically
        setFormdata((prev) => ({
          ...prev,
          country: countryName, // Save the country name
          country_code: value, // Save the country code
          state: "", // Clear state selection
          province_code: "", // Clear province_code selection
        }));
      } else {
        setStates([]); // Clear states if no valid country is selected
        setFormdata((prev) => ({
          ...prev,
          country: value,
          country_code: "", // Clear country code
          state: "", // Clear state name
          province_code: "", // Clear province_code
        }));
      }
      return; // Exit early after handling country change
    }

    // Handle state selection
    if (name === "state") {
      const selectedState = states.find(([stateCode]) => stateCode === value);
      if (selectedState) {
        const [stateCode, stateName] = selectedState;
        setFormdata((prev) => ({
          ...prev,
          state: stateName, // Save the state name
          province_code: stateCode, // Save the state code
        }));
      } else {
        setFormdata((prev) => ({
          ...prev,
          state: value,
          province_code: "", // Clear province_code
        }));
      }
      return; // Exit early after handling state change
    }

    // Update the form data for other inputs
    setFormdata((prevFormdata) => ({
      ...prevFormdata,
      [name]: value,
    }));
  };


  console.log(formdata);

  // const handleToggleChange = (key) => {
  //   setFormdata((prevFormData) => ({
  //     ...prevFormData,
  //     [key]: !prevFormData[key],
  //   }));
  // };

  // const handleBack = () => {
  //   navigate("/customers");
  // };

  const CreateHandler = () => {

    if(formdata?.name === "" || formdata?.email === "" || formdata?.phone === ""){
      toast.error("Please fill required fields and then try again.");
      return;
    }

    setLoading(true);

    let data = JSON.stringify({
      vendorObjId: vendorObjId,
      name: formdata?.name,
      email: formdata?.email,
      phone: formdata?.phone,
      // role: formdata?.role,
      description: formdata?.description,
      city: formdata?.city,
      address: formdata?.address,
      country: formdata?.country,
      country_code: formdata?.country_code,
      province: formdata?.state,
      province_code: formdata?.province_code,
      addressDetails: {
        // "phone": "1234567890",
        // "name": "John Doe",
        zip: formdata?.zip,
        city: formdata?.city,
        address: formdata?.address,
        country: formdata?.country,
        country_code: formdata?.country_code,
        province: formdata?.state,
        province_code: formdata?.province_code,
      }
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/customer/create/action`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response?.data?.success === true) {
          toast.success(response?.data?.message || "Customer created successfully");
          navigate(`/customers`);
          setLoading(false);
        } else {
          toast.error(response?.data?.message || "Failed to create customer");
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  // Custom toggle switch component
  // const Toggle = ({ name, checked, onChange }) => (
  //   <div className="flex justify-between">
  //     <label className="mr-2 text-lg">
  //       {name.charAt(0).toUpperCase() + name.slice(1)}
  //     </label>
  //     <div
  //       onClick={onChange}
  //       className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${checked ? "bg-gray-500" : "bg-gray-300"
  //         }`}
  //     >
  //       <div
  //         className={`bg-white w-3 h-3 lg:w-4 lg:h-4 rounded-full shadow-md transform ${checked ? "translate-x-6" : ""
  //           } transition-transform`}
  //       />
  //     </div>
  //   </div>
  // );
  return (
    <Layout>
      <Container>
        <div className="flex flex-wrap justify-between w-full h-full  overflow-auto">
          <div className="flex flex-col  py-2 px-2 md:px-14 w-full">
            {/* <h2 className="text-2xl font-bold mb-4 text-slate-500 text-center p-4">
                            ADD Customer
                        </h2> */}
            {/* <div className="flex items-center justify-between w-full">
              <BackButtonContainer onClick={handleBack} />
              <h2 className="text-2xl text-center flex-1 text-slate-500 font-bold">
                Add Customer
              </h2>
            </div> */}
            <BackHeader
              title="Add Customer"
              backButton={true}
              link="/customers/all"
              rightSide={
                <div className="text-center my-5">
                  <BlackButton loading={loading} loadingTitle="Adding..." title="Add" handleSubmit={CreateHandler} />
                </div>
              }
            />

            {/* <p className="text-slate-500 font-semibold">Information:</p> */}
            <div className="flex flex-col mt-10">
              <label className="font-semibold">Name :</label>
              <input
                name="name"
                value={formdata.name}
                placeholder="Enter Name"
                className="w-full border border-slate-200 focus:outline-none px-3 py-2 my-2 rounded-lg"
                onChange={handleInputChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="font-semibold">Phone :</label>
              <input
                name="phone"
                value={formdata.phone}
                placeholder="Enter Phone No."
                className="w-full border border-slate-200 focus:outline-none px-3 py-2 my-2 rounded-lg"
                onChange={handleInputChange}
              />
            </div>

            <div className="flex flex-col">
              <label className="font-semibold">Email :</label>
              <input
                name="email"
                value={formdata.email}
                placeholder="Enter Email"
                className="w-full border border-slate-200 focus:outline-none px-3 py-2 my-2 rounded-lg"
                onChange={handleInputChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="font-semibold">Description :</label>
              <input
                name="description"
                value={formdata.description}
                placeholder="Enter Description"
                className="w-full border border-slate-200 focus:outline-none px-3 py-2 my-2 rounded-lg"
                onChange={handleInputChange}
              />
            </div>

            {/* <Form.address /> */}


            <div className="w-full mt-5 md:mt-10 rounded-xl border bg-white p-3 md:p-5 border-r text-sm md:text-base">
              <p className="text-slate-500 font-semibold text-sm md:text-lg">
                Customer Address:
              </p>
              <div className="md:p-5 p-3 flex flex-col gap-3">
                {/* <div className="mt-2 flex  justify-between flex-col md:flex-row gap-3 md:gap-5">
                  <Input.Normal
                    label="Enter Country"
                    name="country"
                    value={formdata.country}
                    placeholder="Enter Country"
                    onChange={handleInputChange}
                  />
                </div> */}

                <div className="mt-2 flex justify-between flex-col ">
                  <label className="block text-sm font-medium text-gray-500">
                    Select Country
                  </label>
                  <select
                    name="country"
                    value={formdata.country_code}
                    onChange={handleInputChange}
                    className="p-2 border border-1 rounded-md border-slate-300 outline-none"
                  >
                    <option value="">Select Country</option>
                    {Object.entries(CountryAndStateData).map(([code, country]) => (
                      <option key={code} value={code}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
                <Input.TextArea
                  label="Enter Address"
                  name="address"
                  rows="5"
                  value={formdata.address}
                  placeholder="Enter Address"
                  onChange={handleInputChange}
                />
                <div className="mt-2 flex  justify-between flex-col md:flex-row gap-3 md:gap-5">
                  <div className="flex justify-between flex-col  w-full">
                    <label className="block text-sm font-medium text-gray-700">
                      Select State
                    </label>
                    <select
                      name="state"
                      value={formdata.province_code}
                      onChange={handleInputChange}
                      className="p-2 border border-1 rounded-md border-slate-300 outline-none"
                    >
                      <option value="">Select State</option>
                      {states.map(([code, name]) => (
                        <option key={code} value={code}>
                          {name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className=' w-full'>
                    <Input.Normal
                      label="Enter City"
                      name="city"
                      value={formdata.city}
                      placeholder="Enter City"
                      onChange={handleInputChange}
                    />
                  </div>
                  {/* <Input.Normal
                    label="Enter State"
                    name="state"
                    value={formdata.state}
                    placeholder="Enter State"
                    onChange={handleInputChange}
                  /> */}
                  <div className='w-full'>
                    <Input.Normal
                      label="Enter ZIP"
                      name="zip"
                      value={formdata.zip}
                      placeholder="Enter ZIP"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>
            </div>



            {/* <div className="flex flex-col">
              <label className="font-semibold">Role :</label>
              <select
                name="role"
                value={formdata.role}
                className="w-full border border-slate-200 focus:outline-none px-3 py-2 my-2 rounded-lg"
                defaultValue=""
                onChange={handleInputChange}
              >
               
                <option value="admin">Admin</option>
                <option value="user">User</option>
              </select>,
            </div> */}
          </div>
        </div>
      </Container>
    </Layout>
  );
}

export default AddCustomer